import type { ReactNode } from "react";
import { useUserContext } from "@/context/UserContext";
import ParentalApprovalRequired from "@/components/ParentalApprovalRequired";

interface RequireApprovalProps {
  children: ReactNode;
}

/**
 * This component blocks access to app features (dashboard, learning, etc.)
 * for users who need parental approval but haven't received it yet.
 * Unlike RequireAuth, this allows onboarding to complete.
 */
export default function RequireApproval({ children }: RequireApprovalProps) {
  const { profile, loading: profileLoading } = useUserContext();

  if (profileLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-slate-950 text-slate-200">
        Loading…
      </div>
    );
  }

  // Check if user requires parental approval but hasn't been approved yet
  if (profile?.parentRequired && !profile?.parentApproved) {
    return <ParentalApprovalRequired parentEmail={profile?.parentEmail} />;
  }

  return <>{children}</>;
}
